import { convertObjToQueryString } from "../../utils/helpers";

export const getUserCurrentActive = (userId: string | undefined) => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_SUBSCRIPTION_URL}/v1/getCurrentActive`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getAllSubscriptionUsers = (queryObj: { [key: string]: any }) => {
  const query = convertObjToQueryString(queryObj);

  return {
    method: "GET",
    url: `${process.env.REACT_APP_SUBSCRIPTION_URL}/v1/subscriptions${query}`,
  };
};

export const changeSubscriptionDate = (
  data: { [key: string]: any },
  userId: string | undefined
) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_SUBSCRIPTION_URL}/v1/change-date`,
    data,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const updateSubscription = (
  data: { [key: string]: any },
  userId: string | undefined
) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_SUBSCRIPTION_URL}/v1/update`,
    data,
    headers: {
      "x-user-id": userId,
    },
  };
};
